// WD Locations — search + area filter; open-status stub until hours parsing exists
(function () {
  const norm = (s) => String(s).toLowerCase().replace(/\s+/g, ' ').trim();

  function init(root) {
    const search = root.querySelector('[data-wd-locations-search]');
    const empty = root.querySelector('[data-wd-locations-empty]');
    if (!search || !empty) return console.error('WD Locations: search or empty element not found');

    const cards = [...root.querySelectorAll('[data-wd-location-card]')];
    let query = '';
    let area = '';

    let animation_timers = [];
    function apply() {
      let visible = 0;
      animation_timers.forEach(timer => clearTimeout(timer));
      animation_timers = [];
      cards.forEach((card) => {
        // split the area string by '|||' and map them
        const cardAreas = (card.dataset.area || '')
          .split('|||')
          .map(norm)
          .filter(Boolean);
        const areaMatch = !area || cardAreas.includes(norm(area));
        const show =
          (!query || norm(card.dataset.search).includes(query)) &&
          areaMatch;
        if (show) {
          card.hidden = false
          animation_timers.push(setTimeout(() => { card.setAttribute("style", "max-height: 100dvh;  opacity: 1;") }, 100))
        }
        else {
          card.setAttribute("style", "max-height: 0; padding-block:0; opacity: 0;")
          animation_timers.push(setTimeout(() => { card.hidden = true }, 400)) // 400 = transition duration
        }
        if (show) visible++;
      });
      if (empty) empty.hidden = visible > 0;
    }

    // search debounce
    let timer;
    const searchInputHandler = (e) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        area = root.querySelector('[data-wd-locations-area]:checked')?.value.trim() || '';
        query = norm(search.value);
        apply()
      }, 100);
    }

    // listen to search events
    search.addEventListener('input', searchInputHandler);
    root.addEventListener('change', searchInputHandler);

    function openedStatusUpdate() {
      function getTimes(times, day) {
        const key = day === 5 ? 'friday' : day === 6 ? 'saturday' : 'week';
        const openingTime_raw = times[key]?.split('-')[0].split(":") || [];
        const closingTime_raw = times[key]?.split('-')[1].split(":") || [];
        return [openingTime_raw, closingTime_raw]
      }

      cards.forEach(async card => {
        /** @type { { week: "10:00-20:15" | null, friday: "10:00-15:15" | null, saturday: "20:00-22:15" | null } } */
        const times = JSON.parse(card.dataset.times);
        const now = new Date();
        const currentTime = now.getHours() * 60 + now.getMinutes();

        const day = now.getDay();
        const [openingTime_raw, closingTime_raw] = getTimes(times, day)

        let nextOpenDay = 0, tomorrowOpeningTime_raw = undefined;
        do {
          nextOpenDay++;
          [tomorrowOpeningTime_raw] = getTimes(times, (day + nextOpenDay) % 7)
        } while ((!tomorrowOpeningTime_raw || tomorrowOpeningTime_raw.length == 0) && nextOpenDay <= 7)
        let nextOpenTimeStr = "לא ידוע";
        if (tomorrowOpeningTime_raw.length > 0) {
          const dayDescribed = ["", "עוד יומיים", "עוד 3 ימים", "עוד 4 ימים", "עוד 5 ימים", "עוד 6 ימים", "עוד שבוע"][nextOpenDay - 1]
          nextOpenTimeStr = `${tomorrowOpeningTime_raw.join(':')}${dayDescribed ? ` ${dayDescribed}` : ""}`
        }   

        const openingTime = Number(openingTime_raw[0]) * 60 + Number(openingTime_raw[1]) || 0;
        const closingTime = Number(closingTime_raw[0]) * 60 + Number(closingTime_raw[1] || 0);

        const isOpen = currentTime >= openingTime && currentTime <= closingTime;

        const template = isOpen ? card.dataset.openedTemplate : card.dataset.closedTemplate;
        const statusEl = card.querySelector('[data-wd-loc-status]');
        if (!statusEl) return console.error('WD Locations: status element not found');
        statusEl.textContent = template.replace('{time}', isOpen ? closingTime_raw.join(':') : nextOpenTimeStr);
        statusEl.classList.toggle('is-closed', !isOpen);

      });
    }
    openedStatusUpdate();
    setInterval(openedStatusUpdate, 60_000 * 1);
  }

  const start = () => init(document.querySelector('[data-wd-locations-root]'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
